/** @file Rows of a timeline layout overlapping a vertical content range (drawing and box select). */
import type { TimelineLayout } from './timelineLayout';

/** [first, endExclusive] row indices overlapping content y in [y0, y1] (any order), clamped to the rows. */
export function timelineRowRange(layout: TimelineLayout, y0: number, y1: number): [number, number] {
  const n = layout.rows.length;
  const first = Math.min(n, Math.max(0, Math.floor(Math.min(y0, y1) / layout.rowHeight)));
  const end = Math.min(n, Math.floor(Math.max(y0, y1) / layout.rowHeight) + 1);
  return [first, Math.max(first, end)];
}
